import { Box, CircularProgress } from '@mui/material';
import Dialog from '@mui/material/Dialog';

interface Props {
  open: boolean;
}

const LoaderFullScreen = (props: Props) => {
  const { open } = props;

  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: { background: 'transparent' },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          overflow: 'hidden',
          height: '100%',
        }}
      >
        <CircularProgress
          size={32}
          thickness={6}
          color='warning'
          sx={theme => ({
            color: '#FFF726',
            ...theme.applyStyles('dark', {
              color: theme.palette.grey[800],
            }),
          })}
        />
      </Box>
    </Dialog>
  );
};

export default LoaderFullScreen;
